import React from 'react';
import 'rc-dialog/assets/bootstrap.css';
import SelectCommon from '../Common/SelectCommonDefault';
import CuartaLinea from './CuartaLinea';


class Emision extends React.Component {

    constructor( props ) {
        super( props );
    }

    render() {
        const {data, tarjetas} = this.props
        const productoCabal = data.GET_PRODUCTO_CABAL_PRODUCTO_ID
        const { GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO } = data
        
        let opcionesPreEmision = [{Id:"0",Descripcion:"Normal"}];
        let opcionesAltaPosDatada = []
        let opcionesRetencionTarjeta = []

        let valoresDefault= {}
        //SI ES UNA MODIFICACION SE REEMPLAZAN LOS DEFAULT POR LOS VALORES SELECCIONADOS EN LA SOLICITUD A MODIFICAR 
        valoresDefault = !tarjetas.esModificacion ? GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO : tarjetas.datosSolicitud 

        if(valoresDefault.SenialPreEmision != undefined  && valoresDefault.SenialPreEmision == "0"){
            valoresDefault["PreEmisionDefault"] = "999999999"
        }else{
            valoresDefault["PreEmisionDefault"] = "1"
        } 

        if(productoCabal){
            if(productoCabal.PreEmision == 1 && productoCabal.ActivacionTelefonica == 0) opcionesPreEmision = [{Id:"1",Descripcion:"PreEmisión sin Activación Telefónica"}];
            if(productoCabal.PreEmision == 1 && productoCabal.ActivacionTelefonica == 1) opcionesPreEmision = [{Id:"1",Descripcion:"PreEmisión con Activación Telefónica"}];
            if(productoCabal.PreEmision == 2 && productoCabal.ActivacionTelefonica == 0) opcionesPreEmision = [{Id:"999999999",Descripcion:"Normal"},{Id:"1",Descripcion:"PreEmisión sin Activación Telefónica"}];
            if(productoCabal.PreEmision == 2 && productoCabal.ActivacionTelefonica == 1) opcionesPreEmision = [{Id:"999999999",Descripcion:"Normal"},{Id:"1",Descripcion:"PreEmisión con Activación Telefónica"}];
            
            if(productoCabal.AltaPosDatada){
                switch(productoCabal.AltaPosDatada){
                    case "S":{
                        opcionesAltaPosDatada = [{Id:"S", Descripcion:"Cuenta con Alta Pos Datada"}]
                        break
                    }
                    case "N":{
                        opcionesAltaPosDatada = [{Id:"N", Descripcion:"Cuenta sin Alta Pos Datada"}]
                        break
                    }
                    case "A":{
                        opcionesAltaPosDatada = [{Id:"S", Descripcion:"Cuenta con Alta Pos Datada"},{Id:"N", Descripcion:"Cuenta sin Alta Pos Datada"}]
                        break
                    }
                    default:
                }
            }
            if(productoCabal.RetencionTarjeta){
                switch(productoCabal.RetencionTarjeta){
                    case "N":{
                        opcionesRetencionTarjeta = [{Id:"N", Descripcion:"Distribución Normal"}]
                        break
                    }
                    case "E":{
                        opcionesRetencionTarjeta = [{Id:"E", Descripcion:"A Cargo de la Entidad"}]
                        break
                    }
                    case "A":{
                        opcionesRetencionTarjeta = [{Id:"N", Descripcion:"Distribución Normal"},{Id:"E", Descripcion:"A Cargo de la Entidad"}]
                        break
                    }
                    default:
                }
            }
        }

    if(productoCabal && data.GET_ATLAS_PARAMETRO_GENERAL.SINODENOMINACIONCUARTALINEA && productoCabal.TipoGrabadoCuartaLinea ||productoCabal &&productoCabal.PreEmision || productoCabal && productoCabal.AltaPosDatada || productoCabal && productoCabal.RetencionTarjeta ){
       return(
           <div className="row">
            <div className="emision col-md-12">
               <div className="divisor-section bottom-separator" >
                   <h2>Emisión </h2>
               </div>
              {productoCabal && <div className="emision-body">
                   <div className="form-group bottom-separator-xs">
                            {(data.GET_ATLAS_PARAMETRO_GENERAL.SINODENOMINACIONCUARTALINEA && productoCabal.TipoGrabadoCuartaLinea) &&
                            <div className="bottom-separator-xs"><label className="label-primary">
                               Grabado 4ta Linea
                            </label>
                            <div >
                                    <CuartaLinea esModificacion={tarjetas.esModificacion} dataTarjetas={tarjetas.solicitudCuenta} tipoGrabado={productoCabal.TipoGrabadoCuartaLinea}  onBlurTextBox={this.props.onBlurTextBox} data={this.props.data}/>
                                    {(!data.ERROR_CUENTA["cuartaLinea"])
                                && <label className="error">{"De ingresar un grabado de cuarta línea, su longitud máxima es de 19 caracteres."}</label>}

                            </div>
                            </div>}
                            {(productoCabal.PreEmision  != null) && <div className="form-group bottom-separator-xs">
                               <label className="label-primary">
                                   Señal de Pre-Emisión 
                                    </label>
                               <SelectCommon nombreAction={"preEmisionId"} infoData={opcionesPreEmision} valorCombo={valoresDefault["PreEmisionDefault"] ? valoresDefault["PreEmisionDefault"] : valoresDefault["SenialPreEmision"] } selecciones={tarjetas.solicitudCuenta} selectCombo={this.props.selectCombo} />

                               {(!data.ERROR_CUENTA["preEmision"])
                                   && <label className="error">{"De seleccionar una señal de pre-emisión."}</label>}

                           </div>}
                           {productoCabal.AltaPosDatada && <div className="form-group bottom-separator-xs">
                               <label className="label-primary">
                                        Señal de Alta Pos Data
                                    </label>
                               <SelectCommon nombreAction={"altaPosDatadaId"} infoData={opcionesAltaPosDatada} valorCombo={valoresDefault["AltaPosdatadaDefault"] ? valoresDefault["AltaPosdatadaDefault"] : valoresDefault["AltaPosdatada"] } selecciones={data} selectCombo={this.props.selectCombo} />

                               {(!data.ERROR_CUENTA["altaPosData"])
                                   && <label className="error">{"De seleccionar una señal de alta pos data."}</label>}

                           </div>}
                           {productoCabal.RetencionTarjeta && <div className="form-group bottom-separator-xs">
                               <label className="label-primary">
                                   Señal de Retención de Tarjetas
                                    </label>
                               <SelectCommon nombreAction={"retencionTarjetaId"} infoData={opcionesRetencionTarjeta} valorCombo={valoresDefault["RetencionTarjetaDefault"] ? valoresDefault["RetencionTarjetaDefault"] : valoresDefault["RetencionTarjeta"] } selecciones={data} selectCombo={this.props.selectCombo} />

                               {(!data.ERROR_CUENTA["retencionTarjetas"])
                                   && <label className="error">{"De seleccionar una señal de retención de tarjetas."}</label>}

                            </div>}
                       
                   </div>
               </div>}
            </div>
           </div>
        
       )}else{
           return <div></div>
       }
    }
}

export default Emision;